const MS_PER_MINUTE = 60 * 1_000;
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

export const DEFAULT_WINDOW_END_MS = 90 * MS_PER_DAY;

export function formatWindowMs(ms: number): { value: number; unit: string } {
  if (ms % MS_PER_DAY === 0) {
    const value = ms / MS_PER_DAY;
    return { value, unit: msg('metrics.definitionSummary.windowDays', { count: value }) };
  }
  if (ms % MS_PER_HOUR === 0) {
    const value = ms / MS_PER_HOUR;
    return { value, unit: msg('metrics.definitionSummary.windowHours', { count: value }) };
  }
  const value = ms / MS_PER_MINUTE;
  return { value, unit: msg('metrics.definitionSummary.windowMinutes', { count: value }) };
}

interface MetricMeasurementWindowProps {
  windowStartOffset?: number;
  windowEndOffset?: number;
}

export function MetricMeasurementWindow({ windowStartOffset, windowEndOffset }: MetricMeasurementWindowProps) {
  const isDefault = windowStartOffset === undefined && windowEndOffset === undefined;
  const endMs = windowEndOffset ?? DEFAULT_WINDOW_END_MS;
  const end = formatWindowMs(endMs);

  const hasStart = windowStartOffset !== undefined && windowStartOffset !== 0;

  if (!hasStart) {
    return (
      <span>
        {isDefault ? (
          <Message
            id="metrics.definitionSummary.windowEndsDefault"
            values={{ value: end.value, unit: end.unit, strong: (chunks) => <strong>{chunks}</strong> }}
          />
        ) : (
          <Message
            id="metrics.definitionSummary.windowEnds"
            values={{ value: end.value, unit: end.unit, strong: (chunks) => <strong>{chunks}</strong> }}
          />
        )}
      </span>
    );
  }

  if (windowEndOffset !== undefined) {
    const start = formatWindowMs(windowStartOffset as number);
    return (
      <span>
        <Message
          id="metrics.definitionSummary.windowStartAndEnd"
          values={{
            startValue: start.value,
            startUnit: start.unit,
            endValue: end.value,
            endUnit: end.unit,
            strong: (chunks) => <strong>{chunks}</strong>,
          }}
        />
      </span>
    );
  }

  return null;
}
